import React, { useEffect, useState } from "react";
import {
  Card, CardContent, CardMedia, Grid, Typography, Box, Button, TextField, Slider, Modal, IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import ApiService from "../../../config/api";
import BoltIcon from "@mui/icons-material/Bolt";
import BedOutlinedIcon from '@mui/icons-material/BedOutlined'; import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined'; import SquareFootIcon from '@mui/icons-material/SquareFoot';
import "./BuyPage.css";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PropertyInquiryModal from "./PropertyInquiryModal ";
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from "react-router-dom";
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import AuthModal from './AuthModal';
import { useSearchParams } from "react-router-dom";


const BuyPage = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");
  const locality = searchParams.get("locality");
  const projectStatus = searchParams.get("projectStatus");
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState("");
  const [title, setTitle] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100000000);
  const [minArea, setMinArea] = useState(0);
  const [maxArea, setMaxArea] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isPriceChanged, setIsPriceChanged] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const location = useLocation();
  const searchResults = location.state?.searchResults || [];
  const [filteredProperties, setFilteredProperties] = useState(properties);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search); // Extract query parameters
    const searchQuery = queryParams.get('search');

    if (searchQuery) {
      const filtered = properties.filter((property) =>
        property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        property.description.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProperties(filtered);
    } else {
      setFilteredProperties(properties);
    }
  }, [location.search, properties]);


  useEffect(() => {
    if (location.state?.searchQuery) {
      setSearchQuery(location.state.searchQuery);
      handleSearch(location.state.searchQuery);
      setIsSearching(true);
    } else {
      getDataFromServer();
    }
  }, [location.state]);

  const handleSearch = async (query) => {
    setLoading(true);
    try {
      const response = await ApiService.get(`/admin/search`, {
        params: {
          searchValue: query || searchQuery,
        },
      });
      setProperties(response.data.meta ? response.data.meta.properties : response.data.data);
      setIsSearching(true);
    } catch (error) {
      console.error("Error during search:", error);
    }
    setLoading(false);
  };


  const getDataFromServer = async () => {
    setLoading(true);
    try {
      let successResponse;

      if (
        city || title || state || country || pincode || isPriceChanged ||
        minPrice || maxPrice || minArea || maxArea || locality || projectStatus
      ) {
        successResponse = await ApiService.getFilter(`/admin/filter`, {
          city,
          title,
          state,
          country,
          pincode,
          minPrice,
          maxPrice,
          minArea,
          maxArea,
          category,
          locality,
          projectStatus
        });
      } else {
        successResponse = await ApiService.getAll(
          `/user/public-listing?category=${encodeURIComponent(category)}&propertyStatus=${projectStatus || ""}`
        );
      }

      const propertiesData =
        successResponse.data.data || successResponse.data.meta.properties;
      setProperties(propertiesData);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };


  useEffect(() => {
    getDataFromServer();
  }, [category]);


  const fetchProperties = async () => {
    try {
      const response = await ApiService.getAll('/user/public-listing');
      setProperties(response.data.meta.properties);
    } catch (error) {
      console.error('Error fetching properties:', error);
    }
  };



  useEffect(() => {
    if (searchResults.length > 0) {
      setProperties(searchResults);
      setIsSearching(true);
    } else {
      setIsSearching(false);
      getDataFromServer();
    }
  }, []);


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setIsSearching(false);
    getDataFromServer();
    setFilterModalOpen(false);
  };

  const clearFilters = () => {
    setCity("");
    setTitle("");
    setState("");
    setCountry("");
    setPincode("");
    setMinPrice('');
    setMaxPrice('');
    setMinArea(0);
    setMaxArea('');
    setIsSearching(false);
    setFilterModalOpen(false);
    setTimeout(() => {
      fetchProperties();
    }, 0);
  };

  const handlePriceChange = (event, newValue) => {
    setMinPrice(newValue[0]);
    setMaxPrice(newValue[1]);
    setIsPriceChanged(true);

  };

  const handleAreaChange = (event, newValue) => {
    setMinArea(newValue[0]);
    setMaxArea(newValue[1]);
  };

  const openInquiryModal = (propertyId) => {
    setSelectedPropertyId(propertyId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  const viewAllListings = () => {
    navigate(`/buyPage`)
  };

  const openFilterModal = () => {
    setFilterModalOpen(true);
  };

  const closeFilterModal = () => {
    setFilterModalOpen(false);
  };


  useEffect(() => {
    const fetchWishlistStatus = async () => {
      try {
        const response = await ApiService.getAll('/user/wishlist');
        const wishlist = response.data.wishlist;
        const wishlistStatusObj = {};

        wishlist.forEach((item) => {
          wishlistStatusObj[item._id] = true;
        });

        setWishlistStatus(wishlistStatusObj);
      } catch (error) {
        console.error('Error fetching wishlist status:', error);
      }
    };

    const role = localStorage.getItem('role');

    if (role === 'user') {
      fetchWishlistStatus();
    }
    getDataFromServer();
  }, []);



  const handleWishlistClick = async (propertyId) => {
    const role = localStorage.getItem('role');

    if (role === 'user') {
      try {
        const response = await ApiService.post(`/user/addWishlist`, { propertyId });
        if (response.status === 200) {
          const message = response.data.message;

          setWishlistStatus((prevState) => ({
            ...prevState,
            [propertyId]: message === 'Property added to wishlist',
          }));
        }
      } catch (error) {
        console.error("Error updating wishlist", error);
      }
    } else {
      setShowModal(true);
    }
  };
  const handleCloseModal = () => setShowModal(false);

  const getWordLimit = (text, limit) => {
    if (!text) return "No description available.";
    const words = text.split(" ");
    if (words.length <= limit) return text;
    return words.slice(0, limit).join(" ") + "...";
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid buyPage-background">
        <div className="mx-lg-5 mx-md-5 mx-sm-0">
          <div className="row center-property">
            <div className="col-md-3 col-lg-3  col-sm-none full-width sticky-filter " >

              <Grid item xs={12} md={2} >
                <Box
                  sx={{
                    position: 'sticky', // Make the filter box sticky
                    top: '20px', // Adjust the distance from the top of the viewport
                    padding: 2,
                    paddingBottom: 3,
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    backgroundColor: 'var(--bs-secondary)',
                    marginBottom: 2,
                    marginTop: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 2,
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      Filters
                    </Typography>
                    <Typography
                      sx={{
                        cursor: 'pointer',
                        color: 'var(--bs-primary)',
                        '&:hover': {
                          color: 'var(--bs-accent)',
                          textDecoration: 'underline',
                        },
                      }}
                      onClick={clearFilters}
                    >
                      Clear Filters
                    </Typography>
                  </Box>
                  <form className="buyPageForm" onSubmit={handleFilterSubmit}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      sx={{}}
                    />
                    <Typography variant="body1" sx={{ marginTop: 2 }}>Price Range</Typography>
                    <Slider
                      value={[minPrice, maxPrice]}
                      onChange={handlePriceChange}
                      valueLabelDisplay="auto"
                      min={0}
                      max={100000000}
                      step={500000}
                      disableSwap
                      sx={{ marginTop: 1, color: "var(--bs-accent)" }}
                      valueLabelFormat={(value) => {
                        if (value >= 10000000 && value < 100000000) {
                          return `${(value / 10000000).toFixed(2)} Cr`;
                        } else if (value >= 100000000) {
                          return `${(value / 10000000).toFixed(0)} Cr`;
                        } else {
                          return `${(value / 100000).toFixed(0)} Lac`;
                        }
                      }}
                    />

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
                        gap: 2,
                        marginTop: 1,
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Min Price"
                        type="number"
                        value={minPrice}
                        onChange={(e) => setMinPrice(Number(e.target.value))}
                      />
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Max Price"
                        type="number"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(Number(e.target.value))}
                      />
                    </Box>


                    <Typography variant="body1" sx={{ marginTop: 1 }}>Area Range (Sq Ft)</Typography>
                    <Slider
                      value={[Number(minArea), Number(maxArea)]}
                      onChange={handleAreaChange}
                      valueLabelDisplay="auto"
                      min={0}
                      max={10000}
                      sx={{ marginTop: 1, color: "var(--bs-accent)" }}
                    />


                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
                        gap: 2,
                        marginTop: 1,
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Min Area"
                        type="number"
                        value={minArea}
                        onChange={(e) => setMinArea(Number(e.target.value))}
                        sx={{ marginTop: 1 }}
                      />
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Max Area"
                        type="number"
                        value={maxArea}
                        onChange={(e) => setMaxArea(Number(e.target.value))}
                        sx={{ marginTop: 1 }}
                      />
                    </Box>



                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      sx={{ marginTop: 1 }}
                    />

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' }, // Stack on small screens, align horizontally on medium and larger screens
                        gap: 2, // Space between the text fields
                        marginTop: 1,
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="State"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        sx={{ marginTop: 1 }}
                      />
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        sx={{ marginTop: 1 }}
                      />
                    </Box>


                    {/* <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Pincode"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value)}
                      sx={{ marginTop: 1 }}
                    /> */}




                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={handleFilterSubmit}

                      sx={{
                        marginTop: 1,
                        backgroundColor: 'var(--bs-accent)',
                        '&:hover': { backgroundColor: 'var(--bs-primary)' }
                      }}
                    >
                      <SearchIcon />
                    </Button>

                    {/* <Button
                      fullWidth
                      variant="outlined"
                      onClick={clearFilters}
                      sx={{
                        marginTop: 1,
                        color: 'var(--bs-primary)',
                        borderColor: 'var(--bs-primary)',
                        '&:hover': { backgroundColor: 'var(--bs-accent)', color: '#fff' }
                      }}
                    >
                      Clear Filters
                    </Button> */}

                  </form>
                </Box>
              </Grid>
            </div>

            <div className="col-lg-9 col-sm-12  col-md-9 full-width" >

              <div className="col-12 d-flex align-items-center px-0 mx-2 justify-content-between">
                <div className="position-relative flex-grow-1" style={{ maxWidth: "90%" }}>
                  <input
                    type="text"
                    className="form-control pe-5"
                    placeholder="Search Properties..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  {searchQuery && (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchQuery("");
                        fetchProperties();
                      }}
                      className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
                      style={{
                        border: "none",
                        background: "transparent",
                        fontSize: "18px",
                        color: "#999",
                        cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>
                  )}
                </div>

                <IconButton
                  onClick={() => handleSearch(searchQuery)}
                  sx={{
                    backgroundColor: 'var(--bs-accent)',
                    '&:hover': { backgroundColor: 'var(--bs-accent)' },
                    color: 'var(--bs-primary)',
                    marginLeft: 1,
                    marginRight: 1,
                    fontSize: '24px',
                  }}
                >
                  <SearchIcon />
                </IconButton>

                <div className="filter-icon">
                  <IconButton onClick={openFilterModal} aria-label="filter">
                    <FilterListIcon sx={{ color: 'var(--bs-accent)', fontSize: '24px' }} />
                  </IconButton>
                </div>
              </div>

              {/* Filter Modal for small screens */}
              <Modal
                open={filterModalOpen}
                onClose={closeFilterModal}
                aria-labelledby="filter-modal-title"
                aria-describedby="filter-modal-description"
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: '80%', md: '60%' }, // Responsive width
                    maxHeight: '90vh', // Ensure the modal fits within the viewport
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    overflowY: 'auto', // Allow scrolling if content overflows
                  }}
                >
                  {/* Close Button */}
                  <IconButton
                    aria-label="close"
                    onClick={closeFilterModal}
                    sx={{ position: 'absolute', top: 10, right: 10 }}
                  >
                    <CloseIcon />
                  </IconButton>

                  <Typography id="filter-modal-title" variant="h5" gutterBottom>
                    Filters
                  </Typography>


                  <form onSubmit={handleFilterSubmit}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      sx={{ marginTop: 2 }}
                    />
                    <Typography variant="body1" sx={{ marginTop: 2 }}>Price Range</Typography>
                    <Slider
                      value={[minPrice, maxPrice]}
                      onChange={handlePriceChange}
                      valueLabelDisplay="auto"
                      min={0}
                      max={100000000}
                      step={500000}
                      sx={{ marginTop: 2, color: "var(--bs-accent)" }}
                      valueLabelFormat={(value) => {
                        return value >= 10000000
                          ? `${(value / 10000000).toFixed(2)} Cr`
                          : `${(value / 100000).toFixed(0)} Lac`;
                      }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Min Price"
                      type="number"
                      value={minPrice}
                      onChange={(e) => setMinPrice(Number(e.target.value))}
                      sx={{ marginTop: 2 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Max Price"
                      type="number"
                      value={maxPrice}
                      onChange={(e) => setMaxPrice(Number(e.target.value))}
                      sx={{ marginTop: 2 }}
                    />

                    {/* Area Range Slider */}
                    <Typography variant="body1" sx={{ marginTop: 2 }}>Area Range (Sq Ft)</Typography>
                    <Slider
                      // value={[minArea, maxArea]}
                      value={[Number(minArea), Number(maxArea)]}
                      onChange={handleAreaChange}
                      valueLabelDisplay="auto"
                      min={0}
                      max={10000}
                      sx={{ marginTop: 2, color: "var(--bs-accent)" }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Min Area"
                      type="number"
                      value={minArea}
                      onChange={(e) => setMinArea(Number(e.target.value))}
                      sx={{ marginTop: 2 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Max Area"
                      type="number"
                      value={maxArea}
                      onChange={(e) => setMaxArea(Number(e.target.value))}
                      sx={{ marginTop: 2 }}
                    />

                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      sx={{ marginTop: 2 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="State"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      sx={{ marginTop: 2 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Country"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      sx={{ marginTop: 2 }}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Pincode"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value)}
                      sx={{ marginTop: 2 }}
                    />

                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      sx={{
                        marginTop: 2,
                        backgroundColor: 'var(--bs-primary)',
                        '&:hover': { backgroundColor: 'var(--bs-accent)' }
                      }}                  >
                      Apply Filters
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={clearFilters}
                      sx={{
                        marginTop: 2,
                        color: 'var(--bs-primary)',
                        borderColor: 'var(--bs-primary)',
                        '&:hover': { backgroundColor: 'var(--bs-accent)', color: '#fff' }
                      }}                  >
                      Clear Filters
                    </Button>
                  </form>
                </Box>
              </Modal>



              <Grid item xs={12} md={9}>
                <div className="house-card-container">
                  {loading ? (
                    <Grid container justifyContent="center" spacing={4} padding={2}>
                      {Array.from(new Array(3)).map((_, index) => (
                        <Grid item xs={12} md={9} key={index} sx={{ marginBottom: 2 }}>
                          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', boxShadow: 3, padding: 2 }}>
                            <Box
                              sx={{ width: { xs: '100%', md: 350 }, height: 250, backgroundColor: '#e0e0e0', borderRadius: 1 }}
                            />
                            <Box sx={{ flexGrow: 1, marginLeft: 2 }}>
                              <Typography variant="h6" sx={{ backgroundColor: '#e0e0e0', height: 30, width: '50%' }}></Typography>
                              <Typography variant="body2" sx={{ backgroundColor: '#e0e0e0', height: 15, width: '80%', marginTop: 2 }}></Typography>
                              <Typography variant="body2" sx={{ backgroundColor: '#e0e0e0', height: 15, width: '60%', marginTop: 1 }}></Typography>
                              <Box sx={{ marginTop: 2 }}>
                                <Typography variant="body2" sx={{ backgroundColor: '#e0e0e0', height: 20, width: '40%' }}></Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  ) : properties.length > 0 ? (

                    <Grid justifyContent="center" spacing={4} marginTop={2}>
                      {filteredProperties.length > 0 ? filteredProperties.map((property) => (
                        <Grid item xs={12} md={9} key={property._id} sx={{ marginBottom: 2, cursor: "pointer" }}>
                          <Card
                            sx={{
                              display: 'flex',
                              flexDirection: { xs: 'column', md: 'row' },
                              justifyContent: 'space-between',
                              boxShadow: 3,
                              padding: { sm: 1, md: 1, lg: 1 },
                              borderRadius: 3,
                              backgroundColor: 'var(--bs-secondary)',
                              color: 'var(--bs-primary)',
                              position: 'relative',
                              overflow: 'hidden',
                            }}
                            className="property-card property-card1"
                          >

                            <CardMedia
                              component="img"
                              className="property-image"
                              sx={{
                                width: { xs: '100%', md: 350 },
                                height: { xs: 250, sm: 260, md: 260 },
                                objectFit: 'cover',
                                borderRadius: 1,
                                transition: 'width 0.4s ease',
                              }}
                              image={property.images[0]}
                              loading="lazy"
                              alt="No Image Available"
                              onClick={() => navigate(`/propertyDescription/${property._id}`)}
                            />

                            {/* Wishlist Icon */}
                            <div
                              style={{
                                position: 'absolute',
                                top: 15,
                                left: 15,
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#d3d3d3',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 1,
                                cursor: 'pointer',
                              }}
                              onClick={() => handleWishlistClick(property._id)}
                            >
                              {wishlistStatus[property._id] ? (
                                <BookmarksIcon sx={{ color: 'var(--bs-accent)' }} />
                              ) : (
                                <BookmarksIcon sx={{ color: '#3d3d3d' }} />
                              )}
                            </div>
                            <AuthModal show={showModal} handleClose={handleCloseModal} navigate={navigate} />

                            {/* Content Area */}
                            <CardContent
                              sx={{
                                flexGrow: 1,
                                marginLeft: { xs: 0, md: 0 },
                                marginTop: { xs: 1, md: 1 },
                                transition: 'flex 0.4s ease',
                                position: 'relative',
                              }}
                            >
                              {property.projectStatus && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  {property.onDemand && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        textAlign:"center",
                                        background: "linear-gradient(90deg, #D6AD60, #b58a44)",
                                        color: "#fff",
                                        px: 1,
                                        py: "2px",
                                        borderRadius: "20px",
                                        fontSize: "0.75rem",
                                        fontWeight: 500,
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                      }}
                                    >
                                      <BoltIcon sx={{ fontSize: 16 }} />
                                      On Demand
                                    </Box>
                                  )}

                                  <Box
                                    sx={{
                                      background: property.projectStatus === "completed"
                                        ? "linear-gradient(135deg, #4caf50, #388e3c)"   
                                        : "linear-gradient(135deg, #ff9800, #e65100)",  
                                      color: "#fff",
                                      px: 1.5,
                                      py: "2px",
                                      borderRadius: "20px",
                                      fontSize: "0.75rem",
                                      width: "90px",
                                      textTransform: "capitalize",
                                      textAlign: "center",
                                      fontWeight: 500,
                                      boxShadow: "0 3px 6px rgba(0,0,0,0.2)", // shadow for depth
                                    }}
                                  >
                                    {property.projectStatus}
                                  </Box>

                                </Box>
                              )}

                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1 }}>
                                <Typography variant="h6" component="div">{getWordLimit(property.title, 4)}</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <CurrencyRupeeIcon />
                                  <Typography variant="h6" sx={{ color: 'var(--bs-primary)', fontWeight: 'bold' }}>
                                    {property.price ? `${property.price.toLocaleString('en-IN')}` : "Price not available"}
                                  </Typography>
                                </Box>
                              </Box>

                              <Typography
                                variant="body2"
                                color="var(--bs-primary)"
                                gutterBottom
                                sx={{
                                  display: '-webkit-box',
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {getWordLimit(property.description, 8)}
                              </Typography>

                              <Typography
                                variant="body2"
                                color="var(--bs-primary)"
                                gutterBottom
                                sx={{
                                  display: "flex",
                                  gap: "2px",
                                  WebkitLineClamp: 1,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                <LocationOnIcon sx={{ fontSize: 16, color: "var(--bs-primary)" }} />
                                {property?.locality?.name || "No Locality"}
                              </Typography>

                              <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <BedOutlinedIcon sx={{ color: '#000', marginRight: 1 }} />
                                  <Typography variant="body2">Bedrooms: {property.numberOfBedrooms}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <BathtubOutlinedIcon sx={{ color: 'var(--bs-primary)', marginRight: 1 }} />
                                  <Typography variant="body2">Bathrooms: {property.numberOfBathrooms}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <SquareFootIcon sx={{ color: '#000', marginRight: 1 }} />
                                  <Typography variant="body2">Area: {property.area} Sq Ft</Typography>
                                </Box>
                              </Box>

                              {/* Buttons */}
                              <Box sx={{ marginTop: 4, display: 'flex', gap: 1 }}>
                                <Button
                                  variant="contained"
                                  onClick={() => navigate(`/propertyDescription/${property._id}`)}
                                  sx={{
                                    backgroundColor: 'var(--bs-accent)',
                                    '&:hover': { backgroundColor: 'var(--bs-accent)' },
                                    color: "var(--bs-primary)",
                                    textTransform: 'none',
                                    width: "100%"
                                  }}
                                >
                                  View Details
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={() => openInquiryModal(property._id)}
                                  sx={{
                                    backgroundColor: 'var(--bs-accent)',
                                    '&:hover': { backgroundColor: 'var(--bs-accent)' },
                                    color: "var(--bs-primary)",
                                    textTransform: 'none',
                                    width: "100%"
                                  }}
                                >
                                  Get a Quote
                                </Button>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      )) : (
                        <></>
                      )}
                    </Grid>

                  ) : (
                    <div className="card m-5 p-5 h-50">
                      <Typography variant="h6" align="center" sx={{ color: 'var(--bs-primary)' }}>
                        No properties found.
                      </Typography>

                    </div>
                  )}
                </div>
              </Grid>
            </div>

          </div>
        </div>
      </div>






      <PropertyInquiryModal open={modalOpen} handleClose={closeModal} propertyId={selectedPropertyId} />
      <Footer />
    </>
  );
};

export default BuyPage;
